
import {computed, ComputedRef, defineComponent, onMounted, Ref, ref, watch, reactive} from 'vue'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import { message, Form } from 'ant-design-vue'
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'

import {StateType as logisticstrackType} from './store'
import {searchType} from './data'
import { validateInfos } from 'ant-design-vue/lib/form/useForm'
const useForm = Form.useForm

interface logisticstrack {
    orderEvents: Ref<any>;
    activeKey: Ref<any>;
    modelRef: searchType;
    validateInfos: ComputedRef<validateInfos>;
    handleShowHide: (e: MouseEvent) => void;
    handleSearch: (e: MouseEvent) => void;
    handleGetKey: (e: MouseEvent) => void;
    handleRest: (e: MouseEvent) => void;
}
export default defineComponent({
    name: 'logisticstrack',
    components:{
        ExclamationCircleOutlined
    },
    setup():logisticstrack {
        const store = useStore<{
            logisticstrack: logisticstrackType,
        }>()
        const activeKey = ref(['1']);
        const orderEvents = ref([])
        const userMsg = (localStorage.getItem('userMsg') && JSON.parse(localStorage.getItem('userMsg') as string)) || {}

        watch(activeKey, val => {
            console.log(val);
        });

        // const orderEvents = computed<any[]>(() => store.state.logisticstrack.orderEvents)
        const getOrderEvents = async(params:searchType) => {
            try {
                const res: boolean = await store.dispatch('logisticstrack/getOrderEventsFn', params)
                if(res === true){
                    console.log(store.state.logisticstrack.orderEvents)
                    if(store.state.logisticstrack.orderEvents.length < 1){
                        message.warning('您输入的物流单号有误，请重新输入')
                    }else{
                        orderEvents.value = store.state.logisticstrack.orderEvents
                    }
                }
            } catch (error) {
                message.warning()
            }
        }

        let isShow = false
        const handleShowHide = async(e: MouseEvent) => {
            if(isShow){
                isShow = false
                activeKey.value = []
            }else{
                isShow = true
                if(store.state.logisticstrack.orderEvents.length > 0){
                    store.state.logisticstrack.orderEvents.map((item:any,index) => {
                        activeKey.value.push(index+1)
                    })
                }
            }
        }

        const modelRef = reactive<searchType>({
            display: true,
            gwosOrderNo: '',
            userCode: userMsg.userCode
        })

         const rulesRef = reactive({
            display:[],
            gwosOrderNo: [],
            userCode:[]
        })

        const { resetFields, validate, validateInfos } = useForm(modelRef, rulesRef)
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
        const handleSearch = async(e: MouseEvent) => {
            e.preventDefault()
            const fieldsValue = await validate<searchType>()
            if(fieldsValue.gwosOrderNo != ''){
                getOrderEvents(fieldsValue)
            }else{
                orderEvents.value = []
            }
        }


        //重置
        const handleRest = async(e: MouseEvent) => {
            e.preventDefault()
            resetFields()
            orderEvents.value = []
        }

        const handleGetKey = async(e: MouseEvent) => {
            activeKey.value = JSON.parse(JSON.stringify(e))
        }

        onMounted(()=>{
            // getOrderEvents({gwtNo:'GS0082400000510N,GS0082300000136N,GS0082300000028N'})
        })

        return {
            activeKey,
            orderEvents,
            handleShowHide,
            modelRef,
            validateInfos:validateInfosNew,
            handleSearch,
            handleGetKey,
            handleRest
        }

    }
})
